/* ------------------------------------------ Global Object ------------------------------ */
if (typeof g === "undefined") {
  var g = new Object();

  sessionStorage.setItem("apiKey", $.cookie("APIKEY"));
  sessionStorage.setItem("apiToken", $.cookie("APITOKEN"));
}

g.hostname = window.location.hostname;
